import { useFeatureFlagsContext } from '@fourthwall/components'

import type { Feature } from './types'

export const useDashboardFeatureFlags = () => {
  const { featureFlags } = useFeatureFlagsContext<Feature>()

  return { dashboardFeatureFlags: featureFlags }
}
